import { t } from '@glory/i18n';
import { Button, EmptyState } from '@glory/ui';
import { TriangleAlert } from 'lucide-react';

/**
 * Необработанная ошибка экрана: по-русски и с понятным следующим шагом вместо стека.
 * Подробности уходят в консоль (и в GlitchTip, когда он будет подключён к фронтенду).
 */
export function RouteError() {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-bg p-6 text-text">
      <EmptyState
        icon={<TriangleAlert />}
        title={<h1>{t('system.crashed')}</h1>}
        description={t('system.crashedLead')}
        action={
          <Button
            variant="primary"
            onClick={() => {
              window.location.reload();
            }}
          >
            {t('system.reload')}
          </Button>
        }
      />
    </main>
  );
}
